import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Logo from '../../../assets/images/logo.png';
import MobileSitemap from './MobileSitemap';

import t5 from '../../../assets/images/t5.png';
import t6 from '../../../assets/images/t6.png';
import t8 from '../../../assets/images/t8.png';
import t9 from '../../../assets/images/t9.png';
import t10 from '../../../assets/images/t10.png';
import t11 from '../../../assets/images/t11.png';
import w3 from '../../../assets/images/w3.png';
import c30 from '../../../assets/images/c30.png';
import c40 from '../../../assets/images/c40.png';
import s100 from '../../../assets/images/s100.png';

import Popup from '../popup/Content.jsx';

export default function Header() {
  const navigate = useNavigate();

  const [activeMenu, setActiveMenu] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [isMobileSitemapOpen, setIsMobileSitemapOpen] = useState(false);

  // 메인메뉴호버
  const handleMenuHover = (index) => {
    setActiveMenu(index);
  };

  // 메뉴밖으로 나가면
  const handleMenuLeave = () => {
    setActiveMenu(null);
    setActiveSubMenu(null);
  };

  // 서브메뉴호버
  const handleSubMenuHover = (subIndex) => {
    setActiveSubMenu(subIndex);
  };

  const handleSubMenuItemHover = (subIndex) => {
    if (subIndex === 'prd1' || subIndex === 'prd2' || subIndex === 'prd3') {
      setActiveSubMenu(subIndex);
    } else {
      setActiveSubMenu(null);
    }
  };

  // 모바일 메뉴 열기
  const handleMobileMenuOpen = () => {
    setIsMobileSitemapOpen(true);
    // 메뉴 열릴 때 스크롤 방지
    document.body.style.overflow = 'hidden';
  };

  // 모바일 메뉴 닫기
  const handleMobileMenuClose = () => {
    setIsMobileSitemapOpen(false);
    // 메뉴 닫힐 때 스크롤 허용
    document.body.style.overflow = 'visible';
  };

  return (
    <>
      <Popup />

      <header>
        <a className="logo absolute pointer" href="/">
          <img src={Logo} alt="크림봇 로고" />
        </a>

        <div className="center">
          <div className="hd relative flex-center m-flex-end">
            {/* 데스크톱 네비게이션 */}
            <nav className="w-100 flex-center desktop-nav t-flex-end">
              <ul className="row-flex-center gap-50 prt-semi-bold fs-20 fc-black1">
                <li
                  className={`row-flex-center menu_item ${
                    activeMenu === 0 ? 'active' : ''
                  }`}
                  onMouseEnter={() => handleMenuHover(0)}
                >
                  <a href="sub1_1" className="menu_link">
                    크림봇
                  </a>
                </li>
                <li
                  className={`row-flex-center menu_item ${
                    activeMenu === 1 ? 'active' : ''
                  }`}
                  onMouseEnter={() => handleMenuHover(1)}
                >
                  <a href="sub2_1_1" className="menu_link">
                    제품소개
                  </a>
                </li>
                <li
                  className={`row-flex-center menu_item ${
                    activeMenu === 2 ? 'active' : ''
                  }`}
                  onMouseEnter={() => handleMenuHover(2)}
                >
                  <a href="sub3_1" className="menu_link">
                    이벤트/소식
                  </a>
                </li>
                <li
                  className={`row-flex-center menu_item ${
                    activeMenu === 3 ? 'active' : ''
                  }`}
                  onMouseEnter={() => handleMenuHover(3)}
                >
                  <a href="sub4_1" className="menu_link">
                    설치사례
                  </a>
                </li>
                <li
                  className={`row-flex-center menu_item ${
                    activeMenu === 4 ? 'active' : ''
                  }`}
                  onMouseEnter={() => handleMenuHover(4)}
                >
                  <a href="sub5_1" className="menu_link">
                    제휴문의
                  </a>
                </li>
                <li
                  className={`row-flex-center menu_item ${
                    activeMenu === 5 ? 'active' : ''
                  }`}
                  onMouseEnter={() => handleMenuHover(5)}
                >
                  <a href="sub6_1" className="menu_link">
                    고객센터
                  </a>
                </li>

                <li
                  className={`row-flex-center menu_item ${
                    activeMenu === 6 ? 'active' : ''
                  }`}
                  onMouseEnter={() => handleMenuHover(6)}
                >
                  <a
                    href="http://creamrental.com"
                    className="menu_link"
                    target="_blank"
                  >
                    크림렌탈
                  </a>
                </li>
              </ul>
            </nav>

            {/* 모바일 햄버거 메뉴 버튼 */}
            <button
              className="mobile_menu_btn mobile-only"
              onClick={handleMobileMenuOpen}
              aria-label="모바일 메뉴 열기"
            >
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </button>
          </div>
        </div>

        {/* 데스크톱 서브메뉴들 */}
        <div className="desktop-nav">
          {/* 서브메뉴 - 크림봇 */}
          {activeMenu === 0 && (
            <div className="sub_menu_container" onMouseLeave={handleMenuLeave}>
              <div className="center">
                <ul className="sub_menu_list prt-light fs-18">
                  <li className="sub_menu">
                    <a href="sub1_1" className="sub_menu_link">
                      회사소개
                    </a>
                  </li>
                  <li className="sub_menu">
                    <a href="sub1_2" className="sub_menu_link">
                      연혁
                    </a>
                  </li>
                  <li className="sub_menu">
                    <a href="sub1_3" className="sub_menu_link">
                      오시는길
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          )}

          {/* 서브메뉴 - 제품소개 */}
          {activeMenu === 1 && (
            <div className="sub_menu_container" onMouseLeave={handleMenuLeave}>
              <div className="center">
                <ul className="sub_menu_list prt-light fs-18">
                  <li
                    className="sub_menu"
                    onMouseEnter={() => handleSubMenuItemHover('prd1')}
                  >
                    <a href="/sub2_1_1" className="sub_menu_link">
                      서빙로봇
                    </a>
                  </li>
                  <li
                    className="sub_menu"
                    onMouseEnter={() => handleSubMenuItemHover('prd2')}
                  >
                    <a href="sub2_2" className="sub_menu_link">
                      물류로봇
                    </a>
                  </li>
                  <li
                    className="sub_menu"
                    onMouseEnter={() => handleSubMenuItemHover('prd3')}
                  >
                    <a href="/sub2_3_1" className="sub_menu_link">
                      청소로봇
                    </a>
                  </li>
                  <li
                    className="sub_menu"
                    onMouseEnter={() => handleSubMenuItemHover('none')}
                  >
                    <a href="/sub2_4" className="sub_menu_link">
                      마케팅
                    </a>
                  </li>
                  <li
                    className="sub_menu"
                    onMouseEnter={() => handleSubMenuItemHover('none')}
                  >
                    <a href="/sub2_5" className="sub_menu_link">
                      매장통합관리솔루션
                    </a>
                  </li>
                </ul>
              </div>

              {/* Third 메뉴 컨테이너 - 서빙로봇 */}
              {activeSubMenu === 'prd1' && (
                <div className="w-100 of-hidden">
                  <div className="third_menu_container flex-center">
                    <ul className="third_menu_list row-flex-center txt-left">
                      <li className="third_menu_item">
                        <a href="/sub2_1_1" className="third_menu_link">
                          <div className="product_image_wrapper">
                            <img
                              src={t10}
                              alt="t10"
                              className="product_image"
                            />
                          </div>
                          <p className="product_name prt-light fs-18 ">
                            배송 및 홍보 전문가
                          </p>
                        </a>
                      </li>
                      <li className="third_menu_item">
                        <a href="/sub2_1_2" className="third_menu_link">
                          <div className="product_image_wrapper">
                            <img src={t8} alt="T8" className="product_image" />
                          </div>
                          <p className="product_name prt-light fs-18 ">
                            최적화된 컴팩트 디자인
                          </p>
                        </a>
                      </li>
                      <li className="third_menu_item">
                        <a href="/sub2_1_3" className="third_menu_link">
                          <div className="product_image_wrapper">
                            <img src={t9} alt="T9" className="product_image" />
                          </div>
                          <p className="product_name prt-light fs-18 ">
                            고하중 중량
                          </p>
                        </a>
                      </li>
                      <li className="third_menu_item">
                        <a href="/sub2_1_4" className="third_menu_link">
                          <div className="product_image_wrapper">
                            <img
                              src={t11}
                              alt="T11"
                              className="product_image"
                            />
                          </div>
                          <p className="product_name prt-light fs-18 ">
                            마케팅 및 초협소 통로 배송 전문가
                          </p>
                        </a>
                      </li>
                      <li className="third_menu_item">
                        <a href="/sub2_1_5" className="third_menu_link">
                          <div className="product_image_wrapper">
                            <img src={t6} alt="T6" className="product_image" />
                          </div>
                          <p className="product_name prt-light fs-18 ">
                            가성비 최고의 모델
                          </p>
                        </a>
                      </li>
                      <li className="third_menu_item">
                        <a href="/sub2_1_5" className="third_menu_link">
                          <div className="product_image_wrapper">
                            <img src={t5} alt="T5" className="product_image" />
                          </div>
                          <p className="product_name prt-light fs-18 ">
                            가성비 최고의 모델
                          </p>
                        </a>
                      </li>
                      <li className="third_menu_item">
                        <a href="/sub2_1_7" className="third_menu_link">
                          <div className="product_image_wrapper">
                            <img src={w3} alt="W3" className="product_image" />
                          </div>
                          <p className="product_name prt-light fs-18 ">
                            보안성과 여러층 배송 가능
                          </p>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {/* Third 메뉴 컨테이너 - 물류로봇 */}
              {activeSubMenu === 'prd2' && (
                <div className="w-100 of-hidden">
                  <div className="third_menu_container flex-center">
                    <ul className="third_menu_list row-flex-center">
                      <li className="third_menu_item">
                        <a href="/sub2_2" className="third_menu_link">
                          <div className="product_image_wrapper">
                            <img
                              src={s100}
                              alt="s100"
                              className="product_image"
                            />
                          </div>
                          <p className="product_name prt-light fs-18 ">
                            고중량 운송로봇
                          </p>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {/* Third 메뉴 컨테이너 - 청소로봇 */}
              {activeSubMenu === 'prd3' && (
                <div className="w-100 of-hidden">
                  <div className="third_menu_container flex-center">
                    <ul className="third_menu_list row-flex-center">
                      <li className="third_menu_item">
                        <a href="/sub2_3_1" className="third_menu_link">
                          <div className="product_image_wrapper">
                            <img
                              src={c30}
                              alt="c30"
                              className="product_image"
                            />
                          </div>
                          <p className="product_name prt-light fs-18 ">
                            자동청소를위한 3in 1 솔루션{' '}
                          </p>
                        </a>
                      </li>
                      <li className="third_menu_item">
                        <a href="/sub2_3_2" className="third_menu_link">
                          <div className="product_image_wrapper">
                            <img
                              src={c40}
                              alt="c40"
                              className="product_image"
                            />
                          </div>
                          <p className="product_name prt-light fs-18 ">
                            중소형 공간에 최적화된 4in 1 상업용 청소 로봇{' '}
                          </p>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* 서브메뉴 - 이벤트 */}
          {activeMenu === 2 && (
            <div className="sub_menu_container" onMouseLeave={handleMenuLeave}>
              <div className="center">
                <ul className="sub_menu_list prt-light fs-18">
                  <li className="sub_menu">
                    <a href="/sub3_1" className="sub_menu_link">
                      크림봇 EVENT
                    </a>
                  </li>
                  <li className="sub_menu">
                    <a href="/sub3_2" className="sub_menu_link">
                      뉴스/소식
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          )}

          {/* 서브메뉴 - 설치사례 */}
          {activeMenu === 3 && (
            <div className="sub_menu_container" onMouseLeave={handleMenuLeave}>
              <div className="center">
                <ul className="sub_menu_list prt-light fs-18">
                  <li className="sub_menu">
                    <a href="/sub4_1" className="sub_menu_link">
                      서빙로봇
                    </a>
                  </li>
                  <li className="sub_menu">
                    <a href="/sub4_2" className="sub_menu_link">
                      청소로봇
                    </a>
                  </li>
                  <li className="sub_menu">
                    <a href="/sub4_3" className="sub_menu_link">
                      인터뷰
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          )}

          {/* 서브메뉴 - 제휴문의 */}
          {activeMenu === 4 && (
            <div className="sub_menu_container" onMouseLeave={handleMenuLeave}>
              <div className="center">
                <ul className="sub_menu_list prt-light fs-18">
                  <li className="sub_menu">
                    <a href="/sub5_1" className="sub_menu_link">
                      제휴업체문의하기
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          )}

          {/* 서브메뉴 - 고객센터 */}
          {activeMenu === 5 && (
            <div className="sub_menu_container" onMouseLeave={handleMenuLeave}>
              <div className="center">
                <ul className="sub_menu_list prt-light fs-18">
                  <li className="sub_menu">
                    <a href="/sub6_1" className="sub_menu_link">
                      제품문의
                    </a>
                  </li>
                  <li className="sub_menu">
                    <a href="/sub6_2" className="sub_menu_link">
                      자가관리방법
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* 모바일 사이트맵 */}
      <MobileSitemap
        isOpen={isMobileSitemapOpen}
        onClose={handleMobileMenuClose}
      />
    </>
  );
}
